import { Box, Button, TextField, Tooltip } from "@mui/material"
import { useState } from "react"
import { toast } from "react-toastify"
import { ContainerHeader, ContainerPage } from "./styles"
import { PageTitle } from "components"
import { stockoutService } from "services/stockoutService"
import { useTableParams } from "hooks/useTableParams"
import { Table } from "shared"

const Stockout = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [scheduledDate, setScheduledDate] = useState(getInitialDeliveryDate())
  const { count, data, params, refresh, onChange, status } = useTableParams({
    service: (params: any) => stockoutService.getAllStockout(params),
  })

  function getInitialDeliveryDate() {
    const now = new Date()
    const hours = now.getHours()

    if (hours >= 7) {
      now.setDate(now.getDate() + 1)
    }

    const localDate = new Date(now.getTime() - now.getTimezoneOffset() * 60000)
      .toISOString()
      .split("T")[0]

    return localDate
  }

  const handleSearchByDate = (date: any) => {
    setScheduledDate(date)
    onChange({ ...params, scheduledDate: date })
  }

  const handleSkuSearch = (skuName: any) => {
    onChange({ ...params, skuName })
  }

  const isPastInitialDate = (date: string) => {
    const initialDate = getInitialDeliveryDate()
    return new Date(date) < new Date(initialDate)
  }

  const handleRevertStockout = async (id: number) => {
    try {
      setIsLoading(true)
      await stockoutService.deleteStockout(id)
      refresh()
      toast("Registro de falta de estoque retirado com sucesso!", { type: "success" })
    } catch (error: any) {
      toast(
        error?.message ??
          "Ocorreu um erro ao obter excluir item sem estoque, dá um alô pro time de tech.",
        { type: "error" },
      )
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <>
      <ContainerPage style={{ height: "auto" }}>
        <ContainerHeader component="header" style={{ display: "flex", flexDirection: "column" }}>
          <PageTitle>Sem Estoque</PageTitle>
          <h2 style={{ marginTop: "10px", fontSize: "1.25rem", color: "#637381", fontWeight: 400 }}>
            Aqui você encontra os SKUs sem estoque reportado pelos abasteces.
          </h2>
        </ContainerHeader>

        <Box display="flex" flexDirection="row" alignItems="center" style={{ marginTop: "20px" }}>
          <TextField
            type="date"
            label="Data de Entrega"
            variant="outlined"
            value={scheduledDate}
            onChange={e => handleSearchByDate(e.target.value)}
            InputLabelProps={{
              shrink: true,
            }}
            style={{ marginRight: "20px" }}
          />
          <TextField
            label="Buscar SKU"
            variant="outlined"
            onChange={e => handleSkuSearch(e.target.value)}
            style={{ marginRight: "20px" }}
          />
        </Box>

        <Table
          columns={[
            {
              style: { fontSize: "1.2rem" },
              field: "updated",
              label: "Horário",
              renderCell: (row: any) => {
                const updated = row?.data?.updated

                const formatedHours = updated
                  ? new Date(updated).toLocaleTimeString("pt-BR", {
                      hour: "2-digit",
                      minute: "2-digit",
                      second: "2-digit",
                    })
                  : "--:--:--"

                return <span>{formatedHours}</span>
              },
            },
            {
              style: { fontSize: "1.2rem" },
              field: "skuName",
              label: "Produto",
            },
            {
              style: { fontSize: "1.2rem" },
              field: "quantity",
              label: "Quantidade faltante",
            },
            {
              style: { fontSize: "1.2rem" },
              field: "replenisher",
              label: "Abastecedor(a)",
            },
            {
              style: { fontSize: "1.2rem" },
              field: "id",
              label: "",
              renderCell: (row: any) => {
                return (
                  <Tooltip
                    title={
                      isPastInitialDate(scheduledDate)
                        ? "Não é possível excluir, registro não é da operação atual."
                        : ""
                    }
                    arrow
                    disableInteractive
                  >
                    <span>
                      {" "}
                      <Button
                        variant="contained"
                        style={{ background: "#f26357", color: "#080707" }}
                        onClick={() => handleRevertStockout(row?.data?.id)}
                        disabled={isPastInitialDate(scheduledDate) || isLoading}
                      >
                        Excluir
                      </Button>
                    </span>
                  </Tooltip>
                )
              },
            },
          ]}
          data={data}
          params={params}
          onChange={onChange}
          refresh={refresh}
          count={count}
          status={status}
          rowStyle={() => ({ ".MuiTableCell-root": { fontSize: "1.1rem" } })}
        />
      </ContainerPage>
    </>
  )
}

export default Stockout
